<template>
    <div>
        <div class="" style="font-family: S-CoreDream-4Regular">
            <v-row class="hidden-sm-and-up justify-center">
                <v-col cols="6" style="" class="">
                    <v-card color="#EFF0F1" elevation="0" class="text-center px-2 py-4 rounded-xl"
                            style="margin-bottom: -20px !important; max-width: 300px;" height="300px">
                        <div class="pa-2"></div>
                        <!--                        <v-icon style="font-size: 55px" color="#89121A">mdi-chart-multiple</v-icon>-->
                        <img height="90px" src="../../../../assets/increase.png" alt="Class Renew Rate Increasing"/>
                        <div style="font-size: 13px" class="pt-2">수업 재연장율</div>
                        <div style="font-family: S-CoreDream-6Bold;font-size: 30px; color: #89121A" class=" ">94%</div>
                        <div style="font-size: 13px" class="pt-2">끊을 수 없는 공부 <br/>계속 듣고 싶은 <br/> 아이비에드</div>
                    </v-card>
                    <div style="padding-top: 25px"></div>

                    <v-card color="#EFF0F1" elevation="0" class="text-center px-2 py-4 rounded-xl"
                            style="margin-bottom: -20px !important; max-width: 300px;" height="300px">
                        <div class="pa-2"></div>
                        <!--                        <div style="font-size: 45px">👩🏻‍🏫🧑🏻‍🏫</div>-->
                        <img height="90px" src="../../../../assets/teacher.png" alt="IVYED Teachers"/>

                        <!--                        <v-icon style="font-size: 55px" color="#89121A">mdi-chart-multiple</v-icon>-->
                        <div style="font-size: 13px" class="pt-2">선생님 만족도</div>
                        <div style="font-family: S-CoreDream-6Bold;font-size: 30px; color: #89121A" class=" ">98점</div>
                        <div style="font-size: 13px" class="pt-2">학생과 잘 맞는 선생님을 매칭해 학습효과 UP!</div>
                    </v-card>
                </v-col>
                <v-col cols="6" style="margin-left: -13px !important;">
                    <v-card style="max-width: 300px;" color="#EFF0F1" elevation="0"
                            class="text-center px-2 py-4 rounded-xl" height="300px">
                        <div class="pa-2"></div>

                        <img height="90px" src="../../../../assets/free-icon-like-3845853.png" alt="IVYED Teachers"/>

                        <div style="font-size: 13px" class="pt-2">학습 만족도</div>
                        <div style="font-family: S-CoreDream-6Bold;font-size: 30px; color: #89121A" class="     ">4.8점
                            <span
                                    style="font-size: 17px; color: black !important;">/5</span></div>
                        <div style="font-size: 13px" class="pt-2">IVY LEAGUE쌤💗 = <br/>높은 학습 만족도</div>

                    </v-card>

                    <div style="padding-top: 5px"></div>
                    <v-card color="#EFF0F1" elevation="0" class="text-center px-2 py-4 rounded-xl"
                            style="max-width: 300px;
                            margin-bottom: -20px !important;" height="300px">
                        <div class="pa-2"></div>
                        <!--                        <div style="font-size: 45px">👩🏻‍🎓🧑🏻‍🎓</div>-->
                        <img height="90px" src="../../../../assets/studyOnlyWithIvyed.png" alt="IVYED can increase students' grades"/>

                        <!--                    <v-icon style="font-size: 55px" color="#89121A">mdi-chart-multiple</v-icon>-->
                        <div style="font-size: 13px" class="pt-2">아이비에드로만 공부</div>
                        <div style="font-family: S-CoreDream-6Bold;font-size: 30px; color: #89121A" class=" ">96%</div>
                        <div style="font-size: 13px" class="pt-2">다른 사교육은 필요 없음! 아이비에드 하나로 충분</div>
                    </v-card>
                </v-col>
            </v-row>
            <div class="hidden-xs-only center-horizontal pt-10">

                <v-row class=" ">

                    <v-card color="#EFF0F1" elevation="0" class="text-center px-2 py-4 rounded-xl"
                            style="margin-bottom: -20px !important; width: 300px;" height="300px">
                        <div class="pa-2"></div>
                        <!--                        <v-icon style="font-size: 55px" color="#89121A">mdi-chart-multiple</v-icon>-->
                        <img height="90px" src="../../../../assets/increase.png" alt="Students Stay Confident with Ivyed"/>
                        <div style="font-size: 16px" class="pt-2">수업 재연장율</div>
                        <div style="font-family: S-CoreDream-6Bold;font-size: 34px; color: #89121A" class=" ">94%</div>
                        <div style="font-size: 16px" class="pt-2">끊을 수 없는 공부 <br/>계속 듣고 싶은 아이비에드</div>
                    </v-card>
                    <div class="px-2"></div>

                    <v-card style="width: 300px;" color="#EFF0F1" elevation="0"
                            class="text-center px-2 py-4 rounded-xl" height="300px">
                        <!--                        <div class="pa-2"></div>-->
                        <!--                        <v-icon style="font-size: 25px" color="#89121A">mdi-star</v-icon>-->
                        <!--                        <v-icon style="font-size: 25px" color="#89121A">mdi-star</v-icon>-->
                        <!--                        <v-icon style="font-size: 25px" color="#89121A">mdi-star</v-icon>-->
                        <!--                        <v-icon style="font-size: 25px" color="#89121A">mdi-star</v-icon>-->
                        <!--                        <v-icon style="font-size: 25px" color="#89121A">mdi-star-half-full</v-icon>-->
                        <!--                        <br/>-->
                        <!--                        <v-icon style="font-size: 45px" color="#89121A">mdi-thumb-up-outline</v-icon>-->
                        <div class="pa-2"></div>

                        <img height="90px" src="../../../../assets/free-icon-like-3845853.png" alt="IVYED Teachers"/>

                        <div style="font-size: 16px" class="pt-2">학습 만족도</div>
                        <div style="font-family: S-CoreDream-6Bold;font-size: 34px; color: #89121A" class="     ">4.8점
                            <span
                                    style="font-size: 17px; color: black !important;">/5</span></div>
                        <div style="font-size: 16px" class="pt-2">IVY LEAGUE쌤💗 = 높은 학습 만족도</div>

                    </v-card>


                </v-row>
                <div class="my-5"></div>
                <v-row>
                    <!--            <div style="padding-top: 25px"></div>-->

                    <v-card color="#EFF0F1" elevation="0" class="text-center px-2 py-4 rounded-xl"
                            style="margin-bottom: -20px !important; width: 300px;" height="300px">
                        <div class="pa-2"></div>
                        <!--                        <div style="font-size: 45px">👩🏻‍🏫🧑🏻‍🏫</div>-->
                        <img height="90px" src="../../../../assets/teacher.png" alt="IVYED Teachers are all trained"/>

                        <!--                        <v-icon style="font-size: 55px" color="#89121A">mdi-chart-multiple</v-icon>-->
                        <div style="font-size: 16px" class="pt-2">선생님 만족도</div>
                        <div style="font-family: S-CoreDream-6Bold;font-size: 34px; color: #89121A" class=" ">98점</div>
                        <div style="font-size: 16px" class="pt-2">학생과 잘 맞는 선생님을 매칭해 <br/>학습효과 UP!</div>
                    </v-card>
                    <div class="px-2"></div>

                    <!--            <div style="padding-top: 5px"></div>-->
                    <v-card color="#EFF0F1" elevation="0" class="text-center px-2 py-4 rounded-xl"
                            style="width: 300px;
                            margin-bottom: -20px !important;" height="300px">
                        <div class="pa-2"></div>
                        <!--                        <div style="font-size: 45px">👩🏻‍🎓🧑🏻‍🎓</div>-->
                        <img height="90px" src="../../../../assets/studyOnlyWithIvyed.png" alt="IVYED is enough for everything"/>

                        <!--                    <v-icon style="font-size: 55px" color="#89121A">mdi-chart-multiple</v-icon>-->
                        <div style="font-size: 16px" class="pt-2">아이비에드로만 공부</div>
                        <div style="font-family: S-CoreDream-6Bold;font-size: 34px; color: #89121A" class=" ">96%</div>
                        <div style="font-size: 16px" class="pt-2">다른 사교육은 필요 없음!<br/> 아이비에드 하나로 충분</div>
                    </v-card>
                </v-row>

            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "ReviewPage2",
        mounted() {
            window.addEventListener("scroll", this.reveal);
        },
        destroyed() {
            window.removeEventListener("scroll", this.reveal);
        },
        methods: {
            reveal() {
                var reveals = document.querySelectorAll(".reveal");

                for (var i = 0; i < reveals.length; i++) {
                    var windowHeight = window.innerHeight;
                    var elementTop = reveals[i].getBoundingClientRect().top;
                    var elementVisible = 150;

                    if (elementTop < windowHeight - elementVisible) {
                        reveals[i].classList.add("active");
                    } else {
                        reveals[i].classList.remove("active");
                    }
                }
            },
        },
    };
</script>

<style>

    body {
        /*background: #42455a;*/
    }

    section {
        /*min-height: 100vh;*/
        /*display: flex;*/
        /*justify-content: center;*/
        /*align-items: center;*/
    }

    .each-title {
        font-size: 21px !important;
        text-align: left !important;
    }

    section:nth-child(1) {
        color: black;
    }

    section:nth-child(2) {
        color: black;
        background: #ffffff !important;
    }

    /* Add more styles for other sections as needed */
    section .container {
        /*margin: 100px;*/
        background-color: #ffffff !important;

    }

    section h1 {
        /*font-size: 3rem;*/
        /*margin: 20px;*/
    }

    section h2 {
        font-size: 40px;
        /*text-align: center;*/
        text-transform: uppercase;
    }

    section .text-container {
        display: flex;
        padding: 20px;
        margin-top: 10px;
    }

    section .text-container .text-box {
        /*margin: 20px;*/
        /*padding: 20px;*/
        /*background: #00c2cb;*/

    }

    section .text-container .text-box h3 {
        font-size: 30px;
        /*text-align: center;*/
        text-transform: uppercase;
        margin-bottom: 10px;
    }

    @media (max-width: 900px) {
        section h1 {
            font-size: 2rem;
            /*text-align: center;*/
        }

        section .text-container {
            flex-direction: column;
        }
    }

    .reveal {
        position: relative;
        transform: translateY(150px);
        opacity: 0;
        transition: 1s all ease;
    }

    .reveal.active {
        transform: translateY(0);
        opacity: 1;
    }

    .center-horizontal {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .center-vertical {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

</style>

